module.exports = __webpack_public_path__ + "img/icon_image.2e70ff0d.svg";